import '../style/home/H_DownloadApp.css';


import app_icon_img from "../../assets/home/rocket.png";

import download_icon from "../../assets/home/Group.png";

 const H_DownloadApp=()=>{
   return(
     <div className="h-download-app">
       <div className="h-download-app-text">
         اینجا جایگاه یک متن <span>ویژه</span> است که باید در این قسمت قرار بگیرد.
       </div>
       <div className="h-download-app-content">
         <div className="h-download-app-content-box1"></div>
         <div className="h-download-app-content-box2">
           <div className="h-download-app-content-box2-app-img-container">
             <img src={app_icon_img} className="h-download-app-content-box2-app-img" alt="app_icon_img" />
           </div>
           <div className="h-download-app-content-box2-text">
             <div className="h-download-app-content-box2-text-title">دانلود اپلیکیشن اختصاصی آزمون</div>
             <div className="h-download-app-content-box2-text-subtitle">به راحتی آب خوردن از کافه بازار و گوناگون...</div>
           </div>
           <img src={download_icon} className="h-download-app-content-box2-download-icon" alt="download_icon"/>
         </div>
       </div>
     </div>
   )
 }


 export default H_DownloadApp;